/** @format */

import { TStore } from '@/redux/helpers/createStore';
import { isEmpty } from 'lodash';
import { ErrorsTypeFields } from './types';

export const selectorBooking = (store: TStore) => store.booking;
export const selectorBookingRoom = (store: TStore) => store.booking.room;
export const selectorBookingAvailability = (store: TStore) => store.booking.availability;
export const selectorBookingContractualConditions = (store: TStore) => store.booking.contractualConditions;
export const selectorBookingCommercialConditions = (store: TStore) => store.booking.commercialConditions;
export const selectorBookingApplicationForm = (store: TStore) => store.booking.applicationForm;
export const selectorBookingContactDetails = (store: TStore) => store.booking.applicationForm.contactDetails;
export const selectorBookingPersonalDetails = (store: TStore) => store.booking.applicationForm.personalDetails;
export const selectorBookingSecondOccupant = (store: TStore) => store.booking.applicationForm.secondOccupant;
export const selectorBookingResidentialAddress = (store: TStore) => store.booking.applicationForm.residentialAddress;
export const selectorBookingCheckInDate = (store: TStore) => store.booking.applicationForm.checkInDate;
export const selectorBookingCheckOutDate = (store: TStore) => store.booking.applicationForm.checkOutDate;
export const selectorBookingLoaders = (store: TStore) => store.booking.loaders;
export const selectorBookingValidCheckOutDates = (store: TStore) => store.booking.applicationForm.validCheckOutDates;
export const selectorBookingError = (store: TStore) => store.booking.error;
export const selectorBookingFormError = (store: TStore) => {
  return [
    store.booking.applicationForm.personalDetailsErrors,
    store.booking.applicationForm.secondOccupantErrors,
    store.booking.applicationForm.residentialAddressErrors,
    store.booking.applicationForm.howDidYouFindUsErrors,
    store.booking.applicationForm.financialValidationErrors,
  ].includes(true);
};
export const selectorBookingFormErrorList = (store: TStore) => {
  return {
    personalDetails: store.booking.applicationForm.personalDetailsErrors,
    secondOccupant: store.booking.applicationForm.secondOccupantErrors,
    residentialAddress: store.booking.applicationForm.residentialAddressErrors,
    howDidYouFindUs: store.booking.applicationForm.howDidYouFindUsErrors,
    financialValidation: store.booking.applicationForm.financialValidationErrors,
  };
};

export const selectorBookingSelectError = (store: TStore, errorType: ErrorsTypeFields) =>
  store.booking.errors[errorType];

export const selectorBookingCreateError = (store: TStore) => {
  return (
    !isEmpty(store.booking.errors.personalDetails) ||
    !isEmpty(store.booking.errors.secondOccupant) ||
    !isEmpty(store.booking.errors.residentialAddress) ||
    !isEmpty(store.booking.errors.financialValidation) ||
    !isEmpty(store.booking.errors.contactDetails)
  );
};

export const selectorBookingErrors = (store: TStore) => store.booking.errors;

export const selectorBookingCurrentStep = (store: TStore) => store.booking.step;
export const selectorBookingOptions = (store: TStore) => store.booking.bookingOptions;
export const selectorBookingFinancialValidation = (store: TStore) => store.booking.applicationForm.financialValidation;
export const selectorHowDidYouFindUs = (store: TStore) => store.booking.applicationForm.howDidYouFindUs;
export const selectorBookingPaymentInfo = (store: TStore) => store.booking.paymentInfo;
export const selectorBookingCouponCode = (store: TStore) => store.booking.couponCode;
